import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { toast } from "react-toastify";
import Button from "@material-ui/core/Button";
import CloseIcon from "@material-ui/icons/Close";
import CheckIcon from "@material-ui/icons/Check";
import "../../../pages/dashboard/styles/dashboard.css";
import { acceptEULAFromDashboard } from "../../../pages/dashboard/actions/dashboardActions";
import ContentWrapper from "../../../common/components/ContentWrapper";
import { fetchAlarmsData } from "../../../common/actions/NotificationTableActions";
import { LicenseAccepted } from "../../../common/actions/MenuActions";
import { signOutFunction } from "../../../common/actions/signoutActions";
import NotificationTable from "../../../common/components/NotificationTable";
import AlertDialogSlide from "../../../common/components/AlertDialog";

const user_id = localStorage.getItem("user_id");
const user_name = localStorage.getItem("username");
const alarm_url = `frontend/alarms/?user_id=${user_id}&user_name=${user_name}`;

class DashboardComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      filterURL: alarm_url + "&page=1&alarm_state=0&",
      page: 1,
      intervalID: null,
      eulaAcceptDialogOpen: false,
      eulaRejectDialogOpen: false,
    };
  }

  componentDidMount() {
    this.props.fetchAlarmsData();
    this.setPeriodicFetch();
  }

  setPeriodicFetch = () => {
    const intervalID = setInterval(() => {
      this.props.fetchAlarmsData(this.state.filterURL);
    }, 30 * 1000);
    this.setState({ intervalID });
  };

  changePage = (page) => {
    const pageLink = page > this.state.page ? this.props.nextLink : this.props.prevLink;
    this.setState({ page, filterURL: pageLink }, () => {
      this.props.fetchAlarmsData(pageLink);
      if (page !== 1) {
        clearInterval(this.state.intervalID);
      } else {
        this.setPeriodicFetch();
      }
    });
  };

  // EULA Dialog Handlers
  handleOpenAcceptEULA = () => this.setState({ eulaAcceptDialogOpen: true });
  handleCloseAcceptEULA = () => this.setState({ eulaAcceptDialogOpen: false });
  handleOpenRejectEULA = () => this.setState({ eulaRejectDialogOpen: true });
  handleCloseRejectEULA = () => this.setState({ eulaRejectDialogOpen: false });

  rejectEULA = () => {
    toast.error("User Rejected License. Logging Out.", {
      autoClose: 5000,
      position: toast.POSITION.TOP_CENTER,
    });
    setTimeout(() => {
      signOutFunction();
    }, 1500);
  };

  // FIXED EULA Not Accepted View
  getContentViewEULANotAccepted = () => {
    return (
      <div
        style={{
          width: "100%",
          minHeight: "100vh",
          padding: "60px 20px 20px", // FIXED: 60px top margin
          margin: "0",
          backgroundColor: "#f4f6f9",
          display: "flex",
          justifyContent: "center",
          alignItems: "flex-start",
        }}
      >
        <div
          style={{
            width: "100%",
            maxWidth: "1000px", // FIXED: Wider for full text visibility
            backgroundColor: "#fff",
            border: "1px solid #ddd",
            borderRadius: "8px",
            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
            overflow: "hidden",
            marginBottom: "20px",
          }}
        >
          {/* Scrollable EULA Content - FIXED HEIGHT */}
          <div
            style={{
              maxHeight: "60vh", // FIXED: Proper scrollable height
              overflowY: "auto",
              padding: "30px", // FIXED: More padding
            }}
          >
            <h3 style={{ textAlign: "center", margin: "0 0 15px", fontSize: "1.4rem" }}>
              Project Yoga BRH EMS – End-User License Agreement
            </h3>
            <p style={{ textAlign: "center", fontSize: "0.9em", color: "#666", marginBottom: "30px" }}>
              © Free Stream Technologies Pvt. Ltd.. All Rights Reserved.
            </p>

            <h4 style={{ margin: "25px 0 10px 0", fontSize: "1.1rem" }}>License Grant</h4>
            <p style={{ marginBottom: "20px", lineHeight: "1.6" }}>
              Free Stream Technologies Pvt. Ltd. (<strong>FreeStream Technologies</strong>) grants you a{" "}
              <strong>non-exclusive, non-transferable, revocable license</strong> to install and use{" "}
              <strong>Project Yoga BRH EMS</strong>
            </p>

            <h4 style={{ margin: "25px 0 10px 0", fontSize: "1.1rem" }}>Permitted Use</h4>
            <p style={{ marginBottom: "15px" }}>You may:</p>
            <ol style={{ marginBottom: "20px", paddingLeft: "20px" }}>
              <li style={{ marginBottom: "8px" }}>Install and run the Software on devices you own or control.</li>
              <li style={{ marginBottom: "8px" }}>Make <strong>one (1) backup copy</strong> for archival purposes only.</li>
            </ol>

            <h4 style={{ margin: "25px 0 10px 0", fontSize: "1.1rem" }}>Restrictions</h4>
            <p style={{ marginBottom: "15px" }}>You <strong>must not</strong>:</p>
            <ol style={{ marginBottom: "20px", paddingLeft: "20px" }}>
              <li style={{ marginBottom: "8px" }}>Distribute, sell, lease, rent, or sublicense the Software.</li>
              <li style={{ marginBottom: "8px" }}>Modify, reverse-engineer, decompile, or disassemble the Software.</li>
              <li style={{ marginBottom: "8px" }}>Remove or alter any copyright, trademark, or proprietary notices.</li>
              <li style={{ marginBottom: "8px" }}>Use the Software for any unlawful purpose or in violation of export controls.</li>
            </ol>

            <h4 style={{ margin: "25px 0 10px 0", fontSize: "1.1rem" }}>Ownership</h4>
            <p style={{ marginBottom: "20px", lineHeight: "1.6" }}>
              The Software and all intellectual property rights therein are and remain the{" "}
              <strong>exclusive property of FreeStream Technologies</strong>. This license does <strong>not</strong> grant any ownership rights.
            </p>

            <h4 style={{ margin: "25px 0 10px 0", fontSize: "1.1rem" }}>No Warranty</h4>
            <p style={{ fontWeight: "bold", marginBottom: "20px", lineHeight: "1.5" }}>
              THE SOFTWARE IS PROVIDED "AS IS" WITHOUT ANY WARRANTIES, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO
              WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR NON-INFRINGEMENT. TEJAS NETWORKS
              DISCLAIMS ALL LIABILITY FOR ANY DAMAGES ARISING FROM USE OF THE SOFTWARE.
            </p>

            <h4 style={{ margin: "25px 0 10px 0", fontSize: "1.1rem" }}>Termination</h4>
            <p style={{ marginBottom: "20px", lineHeight: "1.6" }}>
              This license terminates automatically if you breach any term. Upon termination, you must{" "}
              <strong>destroy all copies</strong> of the Software.
            </p>

            <h4 style={{ margin: "25px 0 10px 0", fontSize: "1.1rem" }}>Support & Contact</h4>
            <p style={{ marginBottom: "20px", lineHeight: "1.6" }}>
              For technical support, licensing queries, or any other assistance:
              <br />
              <strong>Email:</strong> support-ems@freestreamlabs.com
            </p>
          </div>

          {/* Action Buttons - FIXED POSITION */}
          <div
            style={{
              padding: "20px 30px",
              textAlign: "center",
              backgroundColor: "#f8f9fa",
              borderTop: "1px solid #e9ecef",
            }}
          >
            <Button
              variant="outlined"
              color="primary"
              onClick={this.handleOpenAcceptEULA}
              startIcon={<CheckIcon />}
              style={{ margin: "0 15px", minWidth: "180px", height: "40px" }}
            >
              Accept Agreement
            </Button>
            <Button
              variant="outlined"
              color="secondary"
              onClick={this.handleOpenRejectEULA}
              startIcon={<CloseIcon />}
              style={{ margin: "0 15px", minWidth: "180px", height: "40px" }}
            >
              Reject
            </Button>
          </div>
        </div>

        {/* Dialogs */}
        <AlertDialogSlide
          open={this.state.eulaAcceptDialogOpen}
          title="Accept EULA"
          desc="You are going to Accept End User License Agreement. By Clicking 'Yes', you agree, you have read the agreement and agree with the terms of the agreement. Click 'No' if you would like to review the terms and conditions again."
          handleClose={this.handleCloseAcceptEULA}
          action={() => {
            this.props.acceptEULAFromDashboard();
            this.props.LicenseAccepted();
            this.handleCloseAcceptEULA();
          }}
        />

        <AlertDialogSlide
          open={this.state.eulaRejectDialogOpen}
          title="Reject EULA"
          desc="Are you sure you want to Reject End User License Agreement? If you click 'Yes', you will not be able to manage/monitor the devices and will be logged out."
          handleClose={this.handleCloseRejectEULA}
          action={this.rejectEULA}
        />
      </div>
    );
  };

  // EULA Accepted View (Dashboard) - UNCHANGED
  getContentViewEULAAccepted = () => {
    return (
      <div className="content-wrapper">
        <div className="content">
          <div className="row dashboard_boxs">
            <div className="col-lg-4 col-xs-6">
              <a href="/brhdevices">
                <div className="small-box bg-aqua">
                  <div className="inner">
                    <h3>{this.props.activeDevicesCount}</h3>
                    <h4>Active of {this.props.totalDevicesCount} Devices</h4>
                  </div>
                  <div className="icon">
                    <i className="fa fa-laptop" />
                  </div>
                </div>
              </a>
            </div>
            <div className="col-lg-4 col-xs-6">
              <div className="small-box bg-aqua">
                <div className="inner">
                  <h3>{this.props.rebootsCount}</h3>
                  <h4>Reboots across {this.props.totalDevicesCount} Devices</h4>
                </div>
                <div className="icon">
                  <i className="fa fa-history" />
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-xs-6">
              <a href="/notifications">
                <div className="small-box bg-aqua">
                  <div className="inner">
                    <h3>{this.props.totalAlarmsCount}</h3>
                    <h4>New Alarms across {this.props.totalDevicesCount} Devices</h4>
                  </div>
                  <div className="icon">
                    <i className="fa fa-bell-o" />
                  </div>
                </div>
              </a>
            </div>
          </div>

          <NotificationTable
            filterURL={this.state.filterURL}
            page={this.state.page}
            changePage={this.changePage}
          />
        </div>
      </div>
    );
  };

  getContentView = () => {
    return this.props.eulaAccepted
      ? this.getContentViewEULAAccepted()
      : this.getContentViewEULANotAccepted();
  };

  render() {
    return (
      <ContentWrapper
        contentView={this.getContentView()}
        netError={this.props.netError}
      />
    );
  }
}

function mapStateToProps({ menuInfo, notificationTableInfo }) {
  return {
    rebootsCount: menuInfo.rebootsCount,
    activeDevicesCount: menuInfo.activeDevicesCount,
    totalDevicesCount: menuInfo.totalDevicesCount,
    totalAlarmsCount: menuInfo.totalAlarmsCount,
    eulaAccepted: menuInfo.isEULAAccepted,
    netError: notificationTableInfo.netError,
    nextLink: notificationTableInfo.nextLink,
    prevLink: notificationTableInfo.prevLink,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      fetchAlarmsData,
      LicenseAccepted,
      acceptEULAFromDashboard,
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(DashboardComponent);